import styled from "styled-components";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;

  h1 {
    margin-bottom: 30px;
    font-style: italic;
    font-weight: bold;
    font-size: 36px;
    line-height: 54px;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    h1 {
      font-size: 16px;
      line-height: 24px;
    }

    p {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

export const ButtonLink = styled(Link)`
  padding: 10px 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.blue};
  background: none;
  border: 1px solid ${({ theme }) => theme.blue};
  cursor: pointer;
  text-decoration: none;

  &:first-letter {
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }

  &:hover {
    background: ${({ theme }) => theme.blue};
    color: ${({ theme }) => theme.white};
  }
`;

export const ButtonHash = styled(HashLink)`
  padding: 10px 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.blue};
  background: none;
  border: 1px solid ${({ theme }) => theme.blue};
  cursor: pointer;
  text-decoration: none;

  &:first-letter {
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }

  &:hover {
    background: ${({ theme }) => theme.blue};
    color: ${({ theme }) => theme.white};
  }
`;

export const Button = styled.a`
  padding: 10px 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  color: ${({ theme }) => theme.blue};
  text-transform: uppercase;
  background: none;
  border: 1px solid ${({ theme }) => theme.blue};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.blue};
    color: ${({ theme }) => theme.white};
  }
`;

export const Rotate = styled.div`
  transform: rotate(-3deg) translateY(5px);
  transform-origin: bottom left;
`;
